fragment Job on Job {
    _id
    name
    payload
    status
    campaignDetails
    clientDetails
    message
    aborted
    completed
    failed
    created
    progress
    zipUrl
    deliverableProgress
    __typename
}
